/* eslint-disable no-underscore-dangle */
import { action, thunk } from 'easy-peasy';

import type { VizSceneStateModel } from './vizScene';

type VizRendererState = {
  is2DImageVisible: boolean;
  areRingsVisible: boolean;
  leftSidebarExpanded: boolean;
  flipped: boolean;
};

export const vizRendererDefaultState: VizRendererState = {
  is2DImageVisible: true,
  areRingsVisible: true,
  leftSidebarExpanded: true,
  flipped: false,
};

type VizRendererModelSlice = Pick<
  VizSceneStateModel,
  | 'toggle2DImageVisibility'
  | 'setIs2DImageVisible'
  | 'toggleRangeRingsVisibility'
  | 'setAreRangeRingsVisible'
  | 'toggleAngleRulersVisibility'
  | 'setAreAngleRulersVisible'
  | 'setLeftSidebarExpanded'
  | 'setFlipped'
>;

export const vizRendererModel: VizRendererModelSlice = {
  toggle2DImageVisibility: thunk((actions, _, { getState }) => {
    actions.setIs2DImageVisible(!getState().is2DImageVisible);
    actions.recreateObservables();
    return getState().is2DImageVisible;
  }),

  setIs2DImageVisible: action((state, isVisible) => {
    state.is2DImageVisible = isVisible;
  }),

  toggleRangeRingsVisibility: thunk((actions, _, { getState }) => {
    const visible = !getState().areRingsVisible;
    actions.setAreRangeRingsVisible(visible);
    actions._setPointCloudGlobalSettings({ showRangeRings: visible });

    return getState().areRingsVisible;
  }),

  setAreRangeRingsVisible: action((state, isVisible) => {
    state.areRingsVisible = isVisible;
  }),

  toggleAngleRulersVisibility: thunk((actions, _, { getState }) => {
    const visible = !getState().twoDImageSettings.showImageRulers;
    actions.setAreAngleRulersVisible(visible);
    return visible;
  }),

  setAreAngleRulersVisible: action((state, isVisible) => {
    state.twoDImageSettings.showImageRulers = isVisible;
  }),

  setLeftSidebarExpanded: action((state, isExpanded) => {
    state.leftSidebarExpanded = isExpanded;
  }),

  setFlipped: action((state, isFlipped) => {
    state.flipped = isFlipped;
  }),
};
